import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const spinnerVariants = cva(
  "animate-spin rounded-full border-2 border-transparent",
  {
    variants: {
      variant: {
        default: "border-t-white/70 border-r-white/70",
        light: "border-t-white/40 border-r-white/40",
        primary: "border-t-amber-400 border-r-amber-400",
      },
      size: {
        sm: "h-4 w-4 border-2",
        default: "h-6 w-6 border-2",
        md: "h-8 w-8 border-2",
        lg: "h-12 w-12 border-[3px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {
  /**
   * Optional label for accessibility
   */
  label?: string;
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, variant, size, label = "Loading...", ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="status"
        className={cn("flex items-center justify-center", className)}
        aria-label={label}
        {...props}
      >
        <div className={cn(spinnerVariants({ variant, size }))}>
          <span className="sr-only">{label}</span>
        </div>
      </div>
    );
  }
);

Spinner.displayName = "Spinner";

export { Spinner, spinnerVariants };

